<div
  #profileCard
  class="card card-profile"
>
  <div class="pending-container h-100 d-flex flex-column">
    <div class="header">
      <div class="d-flex align-items-center gap-12">
        <i class="icon ic-clock-20"></i>
        <h3>Display Changes</h3>
      </div>

      <div class="header-pending">
        <div class="toggle-container">
          <app-toggle-button
            [switched]="isPendingChangesVisible()"
            [disabled]="disableControls() || isLoading()"
            (switchBtn)="onSwitchButton($event)"
          />

          <div class="toggle-text">Show Display Changes</div>
        </div>

        @if (!trustView()) {
          <div class="vertical-divider"></div>

          <div class="header-generate-docs">
            <button
              type="button"
              class="w-100 d-flex justify-content-center align-items-center gap-8 btn"
              [class]="isOneMoreChecked ? 'btn-primary' : 'btn-secondary'"
              [disabled]="isAllNotChecked || disableControls() || isLoading()"
              (click)="generateDocuments()"
            >
              <i class="icon ic-generate-documents-20"></i>
              Generate Documents
            </button>
          </div>
        }
      </div>
    </div>

    <app-divider/>

    <div class="changes-container-wrapper">
    <div class="changes-container">
      @if (!isLoading()) {
        @for (documentRecord of visibleDocumentRecords(); let first = $first; track $index) {
          <div class="changes-row">
            <div class="changes-info-container">
              <div class="icon-container">
                @if (documentRecord.status === DocumentStatusEnum.Draft) {
                  <i class="icon ic-form-20"></i>
                }
                @if (!trustView() && documentRecord.status === DocumentStatusEnum.AuthorisationPending && documentRecord.type.includes('484')) {
                  <app-checkbox
                    size="small"
                    [value]="selectedDocumentsIdsRecord[documentRecord.documentId]"
                    [disabled]="disableControls()"
                    (change)="selectedDocumentsIdsRecord[documentRecord.documentId] = $event"
                  />
                }
              </div>
              <div class="changes-info">
                <div class="name-container">
                  <app-tooltip [customContent]="true">
                    <div
                      class="action-name"
                      container="body"
                      [ngbTooltip]="documentRecord.description"
                      [tooltipClass]="'tooltip-info'"
                      (click)="checkRolesAndOpen(documentRecord)"
                    >
                      {{ documentRecord.description }}
                    </div>
                  </app-tooltip>
                  <div class="form-name">{{ documentRecord.type | documentType }}</div>
                </div>

                <div class="btn-trash" *appHasRole="['Admin', 'Manager', 'Preparer']">
                  <button
                    type="button"
                    class="btn btn-secondary btn-icon"
                    [disabled]="disableControls() || isAllowToDeleteDocument(documentRecord)"
                    (click)="deleteChanges(documentRecord)"
                  >
                    <i class="icon ic-trash-20"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="status-container">
              <div class="icon-container"></div>
              <app-ag-document-status [status]="documentRecord.status"/>

              <div class="btn-trash">
                <button
                  type="button"
                  class="btn btn-secondary btn-icon"
                  [disabled]="disableControls() || isAllowToDeleteDocument(documentRecord)"
                  (click)="deleteChanges(documentRecord)"
                >
                  <i class="icon ic-trash-20"></i>
                </button>
              </div>
            </div>
          </div>
        } @empty {
          <div class="no-data">No data</div>
        }
      }

      <div class="d-flex align-items-center justify-content-center h-100">
        <app-loader minHeight="100" [loading]="isLoading()"/>
      </div>
    </div>
    </div>

    @if (!isLoading() && !trustView() && pendingDocuments().length) {
      <div class="generate-docs" *appHasRole="['Admin', 'Manager', 'Preparer']">
        <button
          type="button"
          class="w-100 d-flex justify-content-center align-items-center gap-8 btn"
          [class]="isOneMoreChecked || isFirst484FormSelected ? 'btn-primary' : 'btn-secondary'"
          [disabled]="isAllNotChecked || disableControls() || isLoading()"
          (click)="generateDocuments()"
        >
          <i class="icon ic-generate-documents-20"></i>
          Generate Documents
        </button>
      </div>
    }
  </div>
</div>

